// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { buttonTransparent } from "@guestsupply/XDL/PreStyle/button";
import color from "@guestsupply/XDL/Utilities/color";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { IconWrapper } from "@insite/mobius/Icon";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { getProp } from "@insite/mobius/utilities";
import * as React from "react";
import { css } from "styled-components";

export const linkArrowStyle: LinkPresentationProps = {
    icon: {
        iconProps: {
            // src: ArrowRight,
            size: 18,
            color: "primary",
            css: css`
                opacity: 0.33;
                margin-left: 8px;
            `,
        },
        position: "right",
    },
    typographyProps: {
        size: 14,
        ellipsis: true,
        weight: "bold",
        css: css`
            letter-spacing: 0;
            line-height: 16px;
        `,
    },
    css: css`
        justify-content: left;
        // prevent take full width
        align-self: flex-start;

        &:hover {
            & > ${IconWrapper}, & > ${TypographyStyle} {
                color: ${color("common.ui3")};
            }
            & > ${IconWrapper} {
                opacity: 0.8;
            }
        }
    `,
};

interface IconButtonProps {
    typographyProps?: TypographyProps;
}
